import { createSlice, PayloadAction } from "@reduxjs/toolkit";

import { ItemsForm, ItemsRow } from "../types";
import { initialItemsForm, initialState } from "./initialState";

export const sliceKey = "itemsState";

const itemsSlice = createSlice({
  name: sliceKey,
  initialState,
  reducers: {
    getItemsList(state) {
      state.loading = true;
      state.error = null;
    },

    getItemsListSuccess(state, action: PayloadAction<ItemsRow[]>) {
      state.loading = false;
      state.list = action.payload;
      state.error = null;
    },

    getItemsListError(state, action: PayloadAction<string>) {
      state.loading = false;
      state.error = action.payload;
    },

    openAddModal(state) {
      state.isAddModalOpen = true;
      state.error = null;
    },

    closeAddModal(state) {
      state.isAddModalOpen = false;
      state.saving = false;
      state.error = null;
      state.form = initialItemsForm;
    },

    setFormField(
      state,
      action: PayloadAction<{
        name: keyof ItemsForm;
        value: string;
      }>
    ) {
      const { name, value } = action.payload;
      state.form[name] = value;
    },

    resetForm(state) {
      state.form = initialItemsForm;
    },

    addItem(state) {
      state.saving = true;
      state.error = null;
    },

    addItemSuccess(state) {
      state.saving = false;
      state.isAddModalOpen = false;
      state.form = initialItemsForm;
      state.error = null;
    },

    addItemError(state, action: PayloadAction<string>) {
      state.saving = false;
      state.error = action.payload;
    },
  },
});

export const { actions: itemsActions, reducer } = itemsSlice;
